
import { Injectable } from "@angular/core";
import { ApiService } from "@tylertech/core-module";
import { ApprovalLogViewModel, ExecutionResult, LogTypeCriteria } from "@tylertech/tyler-api-types";

/**
 * ApprovalLogService is a generated service implementation. Any edits will be overridden!
 */
@Injectable()
export class ApprovalLogService {
    constructor(private readonly $apiService: ApiService) { }
    
    Get(pType: LogTypeCriteria): Promise<ExecutionResult<ApprovalLogViewModel>> {
        return this.$apiService.sendAuth("IApprovalLogService/Get", pType);
    }
}
